<template lang="pug">
extends ./BaseMessage/ImageMessage.pug
</template>

<script>
import get from 'lodash/get';
import ImageMessage from './BaseMessage/ImageMessage.vue';

export default {
  extends: ImageMessage,
  data() {
    return {
      assetThumbUrl: get(this.message, 'file.payload.thumbnail.url', ''),
      assetUrl: get(this.message, 'file.payload.url', ''),
      assetWidth: get(this.message, 'file.payload.width'),
      assetHeight: get(this.message, 'file.payload.height'),
      acl: get(this.message, 'file.payload.acl', 'public'),
      bucket: get(this.message, 'file.payload.bucket', ''),
      src: get(this.message, 'file.payload.url', ''),
      key: get(this.message, 'file.payload.key', ''),
      thumbnailKey: get(this.message, 'file.payload.thumbnail.key', ''),
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
